module.exports = __webpack_public_path__ + "static/mspiVsMarket-d0d25d35e6fb6e17a4c83d3b439e1eeb.jpg";